module.exports = __webpack_public_path__ + "static/media/26UNRWA13.c5f24986.jpg";